import axios from 'axios';

/* custom helpers */
import { Events } from './Events.js';
import { Store } from './Store.js';
// import { Query } from './Query.js';

/** ----------------------------------------
    Filter Core
 ---------------------------------------- */

/**
 * The core is responsible for all the general
 * filter options and functionality, it
 * provides several options for events, data
 * management and query building.
 */

export class Core extends Events {

    constructor() {
        super();
        this.settings = {};
        this.loading = true;
        this.store = new Store;
        // this.query = new Query;
        // this.delegate();
    }

    /** ----------------------------------------
        Set Filters
     ---------------------------------------- */

    setFilters(input) {
        this.selectEvent(input);
    }

    /** ----------------------------------------
        Update Selected
     ---------------------------------------- */

    _selected(key, value) {
        let selected = this.store.selected;

        if(!selected[key])
            selected[key] = [];

        if(selected[key].indexOf(value) > -1) {
            selected[key].splice(selected[key].indexOf(value), 1);
        } else {
            selected[key].push(value);
        }
    }

    /** ----------------------------------------
        Changed Selected
     ---------------------------------------- */

    selectedChanged(prev, next) {
        let array, result, state;

        if(next.length > prev.length) {
            state = 'added';
            array = { first: next, second: prev };
        } else {
            state = 'removed';
            array = { first: prev, second: next };
        }

        result = array.first.filter((item) => array.second.indexOf(item) > -1 ? false : item);

        let log = {
            state: state,
            original: prev,
            new: next,
            change: result
        };
    }

    /** ----------------------------------------
        Delegate Selected
     ---------------------------------------- */

    /**
     * If the URL contains a query on initial call
     * the Query class will parse the URL and set
     * a selected filters variable. If this query
     * is available the store will inherit these
     * selected properties.
     */

    delegate() {
        if(this.query.selected)
            this.store.selected = this.query.selected;
    }

    /** ----------------------------------------
        Begin
     ---------------------------------------- */

    /**
     * On the initial load of the page take all
     * the results of a specific set of data or
     * a given amount on data.
     */

    default(items = this.settings.data, amount = this.settings.amount) {
        if(this.hasSelected())
            return;

        let reset = this.store.get(items).take(amount);

        this.settings = {
            data: items ? items : this.settings['data'],
            amount: amount ? amount : this.settings['amount']
        };

        this.store.add(reset);
    }

    /** ----------------------------------------
        Update Filter
     ---------------------------------------- */

    /**
     * This method will update the query and the
     * selected state, once the new selected
     * queries are set a promise will resolve
     * a event that can be used to output results.
     */

    update() {
        this.load(true);
        this.default();
        this.resultEvent();

        // let update = new Promise((resolve) => {
        //     resolve(this.buildQuery());
        // });
        //
        // update.then(() => {
        //     this.default();
        //     this.resultEvent();
        // });
        //
        // update.catch(() => {
        //    return new Error('Something went wrong updating the results!');
        // });
    }

    /** ----------------------------------------
        Has Selected
     ---------------------------------------- */

    hasSelected() {
        let types = this.store.get('selected');

        let selections = Object.values(types.data).filter(f => f.length > 0).length;

        return selections > 0;
    }

    /** ----------------------------------------
        Update Query
     ---------------------------------------- */

    buildQuery() {
        this.query.selected = this.store.selected;
        this.query.set();
        return true;
    }

    /** ----------------------------------------
         Load
     ---------------------------------------- */

    /**
     * Set the loading variable within the
     * constructor to either true or false.
     */

    load(boolean) {
        this.loading = boolean;
    }

    /** ----------------------------------------
        Set Result
     ---------------------------------------- */

    /**
     * This method will clean and reset the DOM
     * of the container.
     */

    build(container, html = container) {
        if(!container || container === html)
            container = document.querySelector('#js-results');

        container.innerHTML = '';
        container.insertAdjacentHTML('beforeend', html);

        this.clean();
    }

    /** ----------------------------------------
        Clean Result
     ---------------------------------------- */

    /**
     * This method will clean the results and
     * temporary stored results from the store.
     */

    clean() {
        this.store.clean('results');
        this.store.clean('temp');
    }

    /** ----------------------------------------
        Handle URL
     ---------------------------------------- */

    /**
     * These methods handle the URL that is used
     * within axios. They depend on the host class
     * and therefor it is necessary to pass the
     * host as an option to the main filter class.
     */

    makeUrl(feed) {
        return feed ? this.makePath(feed) : new Error('No feed provided in the configuration');
    }

    makePath(feed) {
        if(feed.includes(this.host.path))
            return;

        return this.host.path + feed;
    }

    /** ----------------------------------------
        Set Feed
     ---------------------------------------- */

    /**
     * The feed method will initiate axios and
     * fetch all the given data that has been
     * declared within the main config file.
     */

    _feed() {
        let config = this.config.feeds;

        let feeds = Object.keys(config).map(item => {
            return axios.get(this.makeUrl(config[item]))
        });

        return this.save(feeds);
    }

    /** ----------------------------------------
        Store Feed
     ---------------------------------------- */

    /**
     * The store method will set a promise on
     * the results that are captured from the
     * response. The data gets stored within
     * the store and a ready event is fired.
     */

    save(feeds) {
        const promise = feeds.map(promise => promise.catch(error => ({ error })));

        return axios.all(promise)
            .then((...urls) => {
                this.store.save(this.config.feeds, urls);
                this.readyEvent();
            })
            .catch(error => {
                return new Error(error);
            });
    }

}